<suite-rfb-collapse title="Título de Eleitor" [collapsed]="true">
  <div class="container-fluid">
    <form [formGroup]="formGroup" (ngSubmit)="onSubmit()">
      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <label [for]="tituloFormGroupName" class="control-label">Número do Título de Eleitor</label>
            <input
              class="form-control"
              type="text"
              [formControlName]="tituloFormGroupName"
              autocomplete="off"
              suiteRfbNumbersOnly>
          </div>

          <div class="form-group">
            <label [for]="nomeFormGroupName" class="control-label">Nome</label>
            <input class="form-control" type="text" [formControlName]="nomeFormGroupName" autocomplete="off">
          </div>

          <div class="form-group">
            <label [for]="nomeMaeFormGroupName" class="control-label">Nome da Mãe</label>
            <input class="form-control" type="text" [formControlName]="nomeMaeFormGroupName" autocomplete="off">
          </div>
        </div>
      </div>

      <div class="row row-align-items-center">
        <div class="col-md-4">
          <div class="form-group">
            <suite-rfb-date-picker
              label="Data de Nascimento"
              direction="top"
              adaptativePosition="true"
              outsideClick="true"
              [suiteRfbMaxDate]="maxDate"
              [formControlName]="dataNascimentoFormGroupName">
            </suite-rfb-date-picker>
          </div>
        </div>

        <div class="col-md-offset-2 col-md-6">
          <div class="form-group">
            <div class="text-center botoes-acoes-formulario">
              <button type="reset" class="btn btn-default" [disabled]="!formGroup.dirty">Limpar</button>
              <button type="submit" class="btn btn-primary" [disabled]="!isValidForm()">Buscar</button>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</suite-rfb-collapse>
